import {
  GET_VERIFIED_LIST,
  GET_VERIFIED_VIEW_LIST,
} from "../../../config/adminUrlConfig";
import { ApiService } from "../../../config/apiServices";

export const getVerifieddataList = (
  roletype,
  perPage,
  currentPage,
  searchData,
  selectedDistrictId,
  selectedCategory,
  selectedSubCategoryId,
  selectedSportId,
  yearValue
) => {
  
  const params = new URLSearchParams();

  // Append all required query params using the function arguments
  params.append("number", perPage);
  params.append("page", currentPage);
  params.append("search", searchData);
  params.append("city", selectedDistrictId);
   params.append("category_type", selectedCategory);
  params.append("sub_category_type", selectedSubCategoryId);
  params.append("sport_id", selectedSportId);

  // Append 'year' only if it's not undefined or empty
  if (yearValue !== undefined && yearValue !== "") {
    params.append("year", yearValue);
  }

  const url = `${GET_VERIFIED_LIST}/${roletype}?${params.toString()}`;
  return ApiService.get(url);
};

export const getAlldataverifiedDwnload = (
  typeId,
  searchData,
  selectedDistrictId,
  selectedSubCategoryId,
  selectedSportId,
  year 
) => {
  let url = `${GET_VERIFIED_LIST}/${typeId}?search=${searchData}&city=${selectedDistrictId}&sub_category_type=${selectedSubCategoryId}&sport_id=${selectedSportId}`;

  // Only add year if it’s not null/undefined/empty
  if (year) {
    url += `&year=${year}`;
  }

  return ApiService.get(url);
};



export const getVerfiedViewByID = (typeId, Id) => {
  return ApiService.get(`${GET_VERIFIED_VIEW_LIST}${typeId}/${Id}`);
};
